<template>
  <div class="contentautPay">
    <van-row class="billList">
      <van-col span="24" class="cardBar" ></van-col>
      <van-col span="24" class="billBox" >
        <van-row class="billBar" v-if="UserNotpayList!=0&&item.defaultFlag==1" v-for="(item,index) in UserNotpayList" :key="'info2-'+index">
          <van-col span="24" class="title">
            <van-col span="18">
              <i class="icon"></i>{{item.heatingYear}}年度热费
            </van-col>
            <van-col span="6">
              <van-tag color="#7e8c8d" round class="tag" plain>{{item.tag}}</van-tag>
            </van-col>
          </van-col>
          <van-col span="24" class="cont">
            <van-col span="24" class="address">{{item.roomInfo.address}}</van-col>
            <van-col span="18" class="bill-money">待缴金额（元）：<span class="orange money">¥{{item.allSumMoney}}</span></van-col>
            <van-col span="6" class="payBtn">
              <van-button round type="danger" class="solidBtn" v-if="item.allSumMoney!=0" @click.stop="paymentBtn(item.roomInfo.roomId)">去缴费</van-button>
              <van-button round type="danger" class="hollowBtn" v-if="item.allSumMoney==0" @click.stop="gotoPath('/reportrepair',item.roomInfo)">去报修</van-button>
            </van-col>
          </van-col >
        </van-row>
        <van-row class="billBar" v-if="UserNotpayList!=0&&item.defaultFlag==0" v-for="(item,index) in UserNotpayList" :key="index">
          <van-col span="24" class="title">
            <van-col span="18">
              <i class="icon"></i>{{item.heatingYear}}年度热费
            </van-col>
            <van-col span="6">
              <van-tag color="#7e8c8d" round class="tag" plain>{{item.tag}}</van-tag>
            </van-col>
          </van-col>
          <van-col span="24" class="cont">
            <van-col span="24" class="address">{{item.roomInfo.address}}</van-col>
            <van-col span="18" class="bill-money">待缴金额（元）：<span class="orange money">¥{{item.allSumMoney}}</span></van-col>
            <van-col span="6" class="payBtn">
				<van-button round type="danger" class="solidBtn" v-if="item.allSumMoney!=0" @click.stop="paymentBtn(item.roomInfo.roomId)">去缴费</van-button>
              <!-- <van-button round type="danger" class="solidBtn" v-if="item.allSumMoney!=0" @click.stop="paymentBtn(item.canPay,item)">去缴费</van-button> -->
              <van-button round type="danger" class="hollowBtn" v-if="item.allSumMoney==0" @click.stop="gotoPath('/reportrepair',item.roomInfo)">去报修</van-button>
            </van-col>
          </van-col >
        </van-row>
      </van-col>
      <van-col span="24" >
        <van-row  span="24" class="noPayBar" v-if="UserNotpayList==0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">未查询到默认地址！</van-col>
        </van-row>
        <van-col span="24" type="flex" justify="space-between" class="barBtn" v-if="UserNotpayList==0">
          <van-button round type="danger" size="large" class="btn" @click="addPayAddress('/addressmanage')">添加地址</van-button>
        </van-col>
      </van-col>
    </van-row>
    <van-action-sheet v-model="isPayShow" title="确认付款">
      <van-row  class="PayPop">
        <van-col span="24" class="money">总缴纳金额（元）</van-col>
        <van-col span="24" class="money"><span class="orange">{{payInfo.allSumMoney}}</span></van-col>
        <van-col span="12" class="Ptext1">缴费</van-col>
        <van-col span="12" class="Ptext2 textR">{{payInfo.companyName}}</van-col>
        <van-col span="12" class="Ptext1">付款方式</van-col>
        <van-col span="12" class="Ptext2 textR">微信</van-col>
        <van-col span="24" type="flex" justify="space-between" class="barBtn">
          <van-button round type="danger" size="large" class="btn" @click.prevent="confirmPayment()">确认并付款</van-button>
        </van-col>
      </van-row>
    </van-action-sheet>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { reqUserNotpayList, reqPayType, reqPayMethod, reqPayOrderAdd } from '../../api'
	export default {
    name:"autpayment",
	  data(){
	    return{
        isPayShow:false,
        roomId:'',
        userId:'',
        UserNotpayList:[],
        Method:{},
        payInfo:{}//当前缴费信息
      }
    },
    created(){
      this.userId = this.$cookies.get('userInfo').userId
	  this.init()
    },
    mounted(){
      
      
    },
    methods:{
		init(){
			/*
			* 查询房屋应缴记录
			* */
			let data={
			  userId:this.userId
			}
			console.log(data)
			if(data.userId){
			  reqUserNotpayList(data).then(res => {
				if(res.success){
				  this.UserNotpayList= res.data
				}else {
				  uni.showToast({
					title: '系统错误，请联系管理员！',
					icon: "none"
				  });
				}
			  })
			}
		},
      //跳转报修
      gotoPath(path,roomInfo){
        let repairAddress = {
          address:roomInfo.address,
          roomId:roomInfo.roomId
        }
        this.$cookies.remove('repairAddress');
        this.$cookies.set('repairAddress',repairAddress);
        this.$router.push({
          path:path,
          name:path.substring(1),
          query:{source:'order'}//标明当前文件
        })
      },
      /*
      * 去添加缴费地址
      * */
      addPayAddress(path){
        this.$router.push({
          path:path,
          name:path.substring(1),
        })
      },
      paymentBtn(roomId){
		  this.$router.push({
		    path:'/paydetail',
		    name:'paydetail',
		    query:{roomId:roomId,isPay:true}
		  });
        // if(canPay){
        //   this.payInfo = payInfo
        //   this.isPayShow = true
        //   this.PayType()
        // }else{
        //   Toast.fail({message:'请前往缴费大厅缴费！',className:'apiLoading'});
        // }
      },
      /*
      *  查询支付类型
      * */
      PayType(){
        let data = {
          companyId:this.payInfo.companyId,
          parentCompanyId:this.payInfo.parentCompanyId
        }
        reqPayType(data).then(res => {
          if(res.success){
            this.PayMethod(res.data[0].id)
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
      },
      /*
      *  查询支付方法
      * */
      PayMethod(payTypeId){
        let data = {
          companyId:this.payInfo.companyId,
          payTypeId:payTypeId
        }
        reqPayMethod(data).then(res => {
          if(res.success){
            this.Method = res.data
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
      },
      /*
      * 确认付款 调下单接口并调用微信支付
      * */
      confirmPayment(){
        let data = {
          userId:this.userId,
          roomId:this.payInfo.roomInfo.roomId,
          methodId:this.Method.id
        }
        reqPayOrderAdd(data).then(res => {
          if(res.success){
            this.onBridgeReady(res.data)
          }else {
            Toast.fail({message:'下单失败！',className:'apiLoading'});
          }
        })
      },
      /*
      * 调微信支付的全局方法
      * */
      onBridgeReady(data){
        let _that = this;
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId":data.resp.appId,     //公众号名称，由商户传入
            "timeStamp":data.resp.timeStamp,         //时间戳，自1970年以来的秒数
            "nonceStr":data.resp.nonceStr, //随机串
            "package":data.resp.package,
            "signType":"MD5",         //微信签名方式：
            "paySign":data.resp.paySign //微信签名
          },
          function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ){
              //支付成功
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              _that.$router.push({
                path:'/payresult',
                name:'payresult',
                query:{result:res.err_msg,roomId:data.order.roomId}
              })
            }
            if(res.err_msg == "get_brand_wcpay_request:cancel"){
              //支付失敗
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              _that.$router.push({
                path:'/payresult',
                name:'payresult',
                query:{result:res.err_msg,roomId:data.order.roomId}
              })
            }
            if(res.err_msg == "get_brand_wcpay_request:fail" ){
              //支付失敗
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              _that.$router.push({
                path:'/payresult',
                name:'payresult',
                query:{result:res.err_msg,roomId:data.order.roomId}
              })
            }
          });
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .contentautPay
    padding 10px 0px
    height 100%
    .orange
      color #ff6d02
    .billList
      position relative
      top -10px
      height 100%
    .cardBar
      height 280px
      background #ff6d02
    .billBox
      position absolute
      top 60px
      left 0px
      overflow scroll
      -webkit-overflow-scrolling: touch;
      height 90%
      padding-bottom 100px
      .billBar
        padding 0px 54px 40px 50px
        background #fff
        border-radius 25px
        margin 25px 30px
        .title
          font-size 26px
          color #999999
          padding 52px 0px 10px
          line-height 54px
          .tag
            float right
            padding 8px 40px
            border 2px solid #c8c9cc
            font-size 24px
          .icon
            display inline-flex
            width 22px
            height 22px
            margin-right 12px
            background url("./images/time_icon.png") no-repeat center
            background-size 100% 100%
        .cont
          font-size 28px
          color #888888
          .bill-money
            padding 14px 0px
            .money
              font-size 36px
        .address
          font-size 30px
          color #222222
          line-height 40px
          padding 5px 0px 10px
        .solidBtn
          width 166px
          height 66px
          font-size 28px
          background #ff6d02
        .hollowBtn
          width 166px
          height 66px
          background transparent!important
          color #ff6d02
          font-size 28px
          border 2px solid #ff6d02
    .barBtn
      padding 55% 40px 0px
      .btn
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        line-height 88px
    .noPayBar
      position absolute
      top 60px
      padding 0px 54px 40px 50px
      background #fff
      border-radius 25px
      margin 7px 30px
      width 78%
      height 480px
      background #ffffff
      text-align center
      .noPayPC
        height 50%
        width 100%
        margin-top 15%
        background url("./images/unfound_5.png") no-repeat center
        background-size 60% auto
      .text1
        font-size 32px
        padding 20px 0px
    .van-action-sheet__header
      height 88px
      font-size 30px
      line-height 80px
    .van-action-sheet__close
      font-size 40px
    .PayPop
      padding 70px 32px
      .money
        text-align center
        font-size 24px
        color #999999
        span
          display inline-flex
          font-size 80px
          padding 32px 0px
      .Ptext1
        height 80px
        line-height 80px
        font-size 32px
        color #222222
        border-bottom 1px solid #f0f0f0
      .Ptext2
        height 80px
        line-height 80px
        font-size 30px
        color #888888
        border-bottom 1px solid #f0f0f0
      .barBtn
        margin-top 100px
        padding 0px 40px
</style>



// WEBPACK FOOTER //
// src/pages/Payment/AutPayment.vue